// startup
// Load entry module and return exports
// This entry module can't be inlined because the eval devtool is used.
let __webpack_exports__ = __webpack_require__("./static/src/app.js");
